import React from 'react';
import { Pagination } from 'react-bootstrap';
interface IProps {
  getChangeLogs: (pageNumber) => void;
  currentPage: number;
  numberOfPages: number;
}

export const ChangeLogsPaginationControls = ({
  getChangeLogs,
  currentPage,
  numberOfPages
}: IProps) => {
  return (
    <Pagination className="justify-content-center">
      <Pagination.First disabled={currentPage === 1} onClick={() => getChangeLogs(1)} />
      <Pagination.Prev
        disabled={currentPage === 1}
        onClick={() => getChangeLogs(currentPage - 1)}
      />
      <Pagination.Next
        disabled={currentPage === numberOfPages}
        onClick={() => {
          getChangeLogs(currentPage + 1);
        }}
      />
      <Pagination.Last
        disabled={currentPage === numberOfPages}
        onClick={() => getChangeLogs(numberOfPages)}
      />
    </Pagination>
  );
};
